"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWeddingsNav = exports.getPublicRegistryNav = exports.getHomestoreNav = exports.getBabyNav = void 0;
var _api = _interopRequireDefault(require("../http/api"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var getWeddingsNav = exports.getWeddingsNav = function getWeddingsNav() {
  return _api.default.get('/website-nav/web-api/weddingsNav');
};
var getPublicRegistryNav = exports.getPublicRegistryNav = function getPublicRegistryNav() {
  return _api.default.get('/website-nav/web-api/publicRegistryNav');
};
var getBabyNav = exports.getBabyNav = function getBabyNav() {
  return _api.default.get('/website-nav/web-api/babyNav');
};
var getHomestoreNav = exports.getHomestoreNav = function getHomestoreNav() {
  return _api.default.get('/website-nav/web-api/homestoreNav');
};